<template>
  <div class="payment-status-container">
    <h1 class="cancel-title">Zahlung storniert ❌</h1>
    <p>Ihre PayPal-Zahlung wurde storniert.</p>
    <p>Sie werden in {{ countdown }} Sekunden zur Startseite weitergeleitet...</p>

    <router-link to="/" class="home-link">Zurück zur Startseite</router-link>
  </div>
</template>
<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'

@Component({})
export default class PaymentCancel extends Vue {
  private countdown = 5

  mounted () {
    this.startCountdown()
  }

  startCountdown () {
    const interval = setInterval(() => {
      this.countdown--
      if (this.countdown <= 0) {
        clearInterval(interval)
        this.$router.push('/')
      }
    }, 1000)
  }
}
</script>

<style scoped>
.payment-status-container {
  max-width: 600px;
  margin: 80px auto;
  text-align: center;
}

.cancel-title {
  color: #d9534f;
}

.home-link {
  display: block;
  margin-top: 20px;
  color: #007bff;
}
</style>
